import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP opt-ins source over the standardized envelope
 * (`GET /analytics/opt-ins-rpp`). Two STANDING totals of registered RPP players
 * opted into email and into SMS, province/BU-aware off the players table.
 * Period-INDEPENDENT (the opt-in flags carry no timestamp), so neither changes
 * with the dashboard date range.
 *
 * Its own source rather than two metrics on `opt-ins`: that endpoint counts app
 * accounts off a different table, and it has one metric where this has two, so
 * `emailOptInsRpp` is a different figure from `emailOptIns` rather than a slice
 * of it. Never read the two as a whole and a part.
 */
export const optInsRppSource = createEnvelopeSource({
    label: 'RPP opt-ins',
    endpoint: 'analytics/opt-ins-rpp',
    metrics: [
        { id: 'emailOptInsRpp', label: 'RPP email opt-ins', type: 'scalar' },
        { id: 'smsOptInsRpp', label: 'RPP SMS opt-ins', type: 'scalar' },
    ],
    forms: ['number'],
    regionGrain: 'province',
});
